//@flow
import _ from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import ListagemPage from '../../components/templates/ListagemPage';
import { tableHelper } from '../../helpers/tableHelper';
import { clienteService } from '../../services/cliente.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import ClienteCrudListFilter from './ClienteCrudListFilter';
import withAbility from '../../hoc/withAbility';

const endPoint = '/cliente/novo/';
const endPointView = '/cliente/';
class ClienteCrudList extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);
    this.columns = [
      {
        path: 'nomeFantasia',
        title: 'Nome Fantasia',
        isKey: false,
        dataSort: false,
        className: 'txtBold',
        hidden: true,
      },
      {
        path: 'label',
        title: 'Nome Fantasia App',
        isKey: false,
        dataSort: false,
        className: 'txtBold',
        width: '450px',
      },
      {
        path: 'razaoSocial',
        title: 'Razão social',
        isKey: false,
        dataSort: false,
      },
      {
        path: 'codigoCliente',
        title: 'Código Cliente',
        isKey: false,
        dataSort: false,
      },
      {
        path: 'cnpjCpf',
        title: 'Cnpj/Cpf',
        isKey: true,
        dataSort: false,
        className: 'txtBold',
        isCpfCnpj: true,
      },
      {
        path: 'statusWms',
        title: 'Status WMS',
        isKey: false,
        dataSort: false,
        width: '150px',
      },
    ];
    const fields = this.columns.map((col) => col.path);
    const labels = this.columns.map((col) => col.title);

    this.state = {
      labels,
      fields,
    };
  }

  handleRowClick = (row: e) => {
    if (this.props.ability.can('update', 'Cliente')) {
      this.props.history.push(endPointView + row.id);
    }
  };
  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
  };
  render() {
    const fields = this.state.fields;
    const tableColumn = _.map(this.columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={tableHelper.renderCustom}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Clientes"
          subTitle=" "
          canBack={false}
        />
        <ListagemPage
          // title={`Clientes`}
          newButtonActionClick={() => {
            // this.props.history.push('/cliente/novo');
          }}
          delete={() => {}}
          service={clienteService}
          showNewButton={false}
          labelNewButton="Novo Cliente"
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={{}}
          onRowClick={this.handleRowClick}
          FormFilter={ClienteCrudListFilter}
          fields={fields}
          array={'clientes'}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(withAbility(ClienteCrudList));
